import { render, staticRenderFns } from "./DialogBerth.vue?vue&type=template&id=7bfb6707&"
import script from "./DialogBerth.vue?vue&type=script&lang=js&"
export * from "./DialogBerth.vue?vue&type=script&lang=js&"
import style0 from "./DialogBerth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports